import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Badge from 'flarum/common/components/Badge';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import PostControls from 'flarum/forum/utils/PostControls';
import UserControls from 'flarum/forum/utils/UserControls';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import BanUserModal from './components/BanUserModal';
export { default as extend } from './extend';
app.initializers.add('clarkwinkelmann-shadow-ban', () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!discussion.attribute('canShadowHide')) {
      return;
    }
    const hidden = discussion.attribute('isShadowHidden');
    items.add('shadow-hide', Button.component({
      icon: 'fas fa-volume-mute',
      onclick() {
        discussion.save({
          isShadowHidden: !hidden
        }).then(() => {
          m.redraw();
        });
      }
    }, app.translator.trans('clarkwinkelmann-shadow-ban.forum.discussionControl.' + (hidden ? 'restore' : 'hide'))));
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    if (!post.attribute('canShadowHide')) {
      return;
    }
    const hidden = post.attribute('isShadowHidden');
    items.add('shadow-hide', Button.component({
      icon: 'fas fa-volume-mute',
      onclick() {
        post.save({
          isShadowHidden: !hidden
        }).then(() => {
          m.redraw();
        });
      }
    }, app.translator.trans('clarkwinkelmann-shadow-ban.forum.postControl.' + (hidden ? 'restore' : 'hide'))));
  });
  extend(UserControls, 'moderationControls', function (items, user) {
    if (!user.attribute('canShadowBan')) {
      return;
    }
    items.add('shadow-ban', Button.component({
      icon: 'fas fa-volume-mute',
      onclick() {
        app.modal.show(BanUserModal, {
          user
        });
      }
    }, app.translator.trans('clarkwinkelmann-shadow-ban.forum.userControl.ban')));
  });
  extend(User.prototype, 'badges', function (items) {
    const until = this.attribute('shadowBannedUntil');
    if (until && new Date() < new Date(until)) {
      items.add('shadow-banned', Badge.component({
        icon: 'fas fa-volume-mute',
        type: 'shadow-banned',
        label: app.translator.trans('clarkwinkelmann-shadow-ban.forum.badge.user')
      }));
    }
  });
  extend(Discussion.prototype, 'badges', function (items) {
    if (this.attribute('isShadowHidden')) {
      items.add('shadow-banned', Badge.component({
        icon: 'fas fa-volume-mute',
        type: 'shadow-banned',
        label: app.translator.trans('clarkwinkelmann-shadow-ban.forum.badge.discussion')
      }));
    }
  });
  extend(CommentPost.prototype, 'elementAttrs', function (attrs) {
    // @ts-ignore missing type-hint in Flarum
    const post = this.attrs.post;
    if (post.attribute('isShadowHidden')) {
      attrs.className = (attrs.className || '') + ' Post--hidden Post--shadow-hidden';
    }
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    // @ts-ignore missing type-hint in Flarum
    const post = this.attrs.post;

    // Add same button as hidden toggle
    if (post.attribute('isShadowHidden')) {
      items.add('shadow-hidden', m('span.ShadowHiddenPostBadge', app.translator.trans('clarkwinkelmann-shadow-ban.forum.badge.post')));
      if (!items.has('toggle')) {
        items.add('toggle', Button.component({
          className: 'Button Button--default Button--more',
          icon: 'fas fa-ellipsis-h',
          onclick: this.toggleContent.bind(this)
        }));
      }
    }
  });
  extend(DiscussionListItem.prototype, 'elementAttrs', function (attrs) {
    // @ts-ignore missing type-hint in Flarum
    const discussion = this.attrs.discussion;
    if (discussion.attribute('isShadowHidden')) {
      attrs.className = (attrs.className || '') + ' DiscussionListItem--hidden DiscussionListItem--shadow-hidden';
    }
  });
});